module.exports = __webpack_public_path__ + "img/SDMO-landing.714e7016.jpg";